import { useState, useEffect, useCallback } from 'react';
import { azureFetch } from '../../../api/azureFetch';

const steps = ["Old Model Moved To OBSERVATION", "Model Promoted To LIVE", "Alerts Re-created"];

const usePromoteModelStatus = (id, setSelectedSensors) => {
    const [statusResults, setStatusResults] = useState();
    const [loading, setLoading] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);

    const refreshStatus = useCallback(() => {
        if (!id) return;

        setLoading(true);
        azureFetch(`getPromoteToLiveJobDetails/${id}`).then((res) => {
            setStatusResults(res);
            const completedStepIndex = steps.findIndex(
                (step) => step === res?.job_status
            );

            if (completedStepIndex !== -1) {
                setCurrentStep(completedStepIndex + 1);

                // Update selected sensors if all steps are completed
                if (completedStepIndex === steps.length - 1 && setSelectedSensors) {
                    const selectedSensors = res?.sensors.map(sensor => {
                        return {
                            id: sensor,
                            status: "LIVE"
                        }
                    });
                    const strigifySensors = selectedSensors.map(sensor => JSON.stringify(sensor));
                    setSelectedSensors(strigifySensors);
                }
            }
        }).catch((error) => {
            console.error('Error fetching promote model status:', error);
        }).finally(() => {
            setLoading(false);
        });
    }, [id, setSelectedSensors]);

    useEffect(() => {
        refreshStatus();
    }, [refreshStatus]);

    return {
        statusResults,
        loading,
        currentStep,
        steps,
        refreshStatus,
        isCompleted: currentStep > steps.length - 1
    };
};

export default usePromoteModelStatus;
